// @avantia common-code
import {
  HpRemoveEndingProps,
  HpRemoveEndingResult,
  HpVisibleQuestionCustomization
} from './questionSetToolsCustomizationInterface';

export const visibleQuestionDescriptiveCustomization: HpVisibleQuestionCustomization = {
  name: 'policyApi',
  ignoreRepeaterWithNoGroup: false,
  removeEnding,
  splitQuestionId
};

function splitQuestionId(questionId: string): string[] {
  return questionId.split('_');
}

function removeEnding({ indexes, parts }: HpRemoveEndingProps): HpRemoveEndingResult {
  const len = parts.length;
  let res: string[];
  let isIndexer = parts[len - 1] === 'i';
  if (isIndexer) {
    res = parts.slice(0, len - 2);
  } else {
    res = parts.slice(0, len - 1);
  }

  let count = 0;
  for (let i = 0; i < res.length; i++) {
    if (res[i] === 'i') {
      count++;
    }
  }

  const ix = indexes ? indexes.slice(0, count) : [];
  let grpNo: number | undefined;
  isIndexer = res[res.length - 1] === 'i';
  if (isIndexer) {
    grpNo = indexes ? indexes[indexes.length - 1] : undefined;
  }

  return { indexes: ix, parts: res, groupNumber: grpNo };
}
